import { httpClient2 } from "modules/core/utils/httpClient2";

import { IFileAttachment } from "modules/core/types/entities";

export const getChatPresignedUrls = async ({
  files
}: {
  files: Array<{
    id: string;
    name: string;
    type: string;
  }>;
}): Promise<IFileAttachment[]> => {
  const response = await httpClient2.post<IFileAttachment[]>(
    "/ai/attachments/presign_urls",
    { files }
  );

  return response.data;
};
